var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import PropTypes from "prop-types";
import React, { PureComponent } from "react";
import Async from "react-select/async";
import { Preloader } from "../..";

var LoadingIndicator = function LoadingIndicator() {
  return React.createElement(Preloader, { size: 21, color: "rgba(0,0,0,.6)", style: { marginRight: "5px" } });
};

var SelectAsyncComponent = function (_PureComponent) {
  _inherits(SelectAsyncComponent, _PureComponent);

  function SelectAsyncComponent() {
    _classCallCheck(this, SelectAsyncComponent);

    return _possibleConstructorReturn(this, _PureComponent.apply(this, arguments));
  }

  SelectAsyncComponent.prototype.render = function render() {
    var _props = this.props,
        bsSize = _props.bsSize,
        children = _props.children,
        className = _props.className,
        components = _props.components,
        forwardedRef = _props.forwardedRef,
        props = _objectWithoutProperties(_props, ["bsSize", "children", "className", "components", "forwardedRef"]);

    var baseClassName = "uit-react-select";
    return React.createElement(
      Async,
      _extends({}, props, {
        className: [
        // Add any additional classes that may have been added
        className ? className : "", baseClassName,
        // We'll control the sizing of the input via these CSS classes
        bsSize === "lg" || bsSize === "large" ? "uit-react-select--lg" : "", bsSize === "sm" || bsSize === "small" ? "uit-react-select--sm" : ""].join(" "),
        classNamePrefix: baseClassName,
        components: _extends({}, components ? components : {}, {
          LoadingIndicator: LoadingIndicator
        }),
        ref: forwardedRef
      }),
      children
    );
  };

  return SelectAsyncComponent;
}(PureComponent);

export { SelectAsyncComponent as default };
SelectAsyncComponent.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node,
  className: PropTypes.string,
  components: PropTypes.array,
  forwardedRef: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  bsSize: PropTypes.oneOf(["lg", "large", "sm", "small"])
} : {};